import PropTypes from 'prop-types';
import React from 'react';
import {formatCurrency} from 'utils/CurrencyFormatting';

export default function GreyhoundRacingRaceDetails(props) {
  require('./GreyhoundRacingRaceDetails.scss');
  const {
    race: {
      race_summary : {
        straight_forecast: forecast,
        tricast,
        off_time: raceOffTime,
        winning_time: raceWinningTime
      },
      runs: raceRunners,
      winning_trainer: {
        name: winningTrainer
      } = {
        name: "Not Available"
      }
    }
  } = props;

  return <div className="gh-racecard-result-details-wrapper">
    <div className="gh-racing-racecard-section-header">
      <h4>Race Details</h4>
    </div>
    <ul className="gh-race-details-summary">
      <SummaryElement label="Winning Trainer">{winningTrainer}</SummaryElement>
      <SummaryElement label="Winning Time">{raceWinningTime}</SummaryElement>
      <SummaryElement label="Runners">{`${raceRunners.length} ran`}</SummaryElement>
      <SummaryElement label="Distances">{concatRunnerDistances([...raceRunners])}</SummaryElement>
      <SummaryElement label="Off Time">{raceOffTime}</SummaryElement>
      <SummaryElement label="Forecast">{formatCurrency(forecast, 'GBP')}</SummaryElement>
      <SummaryElement label="Tricast">{formatCurrency(tricast, 'GBP')}</SummaryElement>
    </ul>
  </div>;
}

function concatRunnerDistances(runs) {
  return runs.map(r => {
    return r.finish_distance;
  }).filter(s => s).join(", ");
}

GreyhoundRacingRaceDetails.propTypes = {
  race: PropTypes.object
}

function SummaryElement({label, children}) {
  return (
    <li>
      <span className="gh-race-details-summary-label">{label}</span>
      <span className="gh-race-details-summary-value">{children}</span>
    </li>
  );
}

SummaryElement.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  children: PropTypes.node.isRequired
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRaceDetails.js